import React from "react";
import { Box, StyledText } from "../../../../components/common";
import { CheckCircle, SmsRefresh } from "../../../../components/svgs";

const ReferralStatusCard = ({ contact, date, status, cardStatus, hideStatusText, datePreText = "Joined on" }) => {
  return (
    <Box
      style={{
        display: "flex",
        backgroundColor: "transparent",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
          backgroundColor: "white",
          padding: 15,
          borderRadius: 10,
        }}
      >
        <div>
          <StyledText
            style={{
              fontFamily: "MTNRegular",
              margin: 0,
              fontSize: 13,
            }}
          >
            {contact}
          </StyledText>
          <StyledText
            style={{
              fontFamily: "MTNRegular",
              margin: 0,
              fontSize: 11,
              marginTop: 5,
              color: "#7F7F7F",
            }}
          >
            {datePreText} {date}
          </StyledText>
        </div>
        <div style={{ display: "flex" }}>
          <StyledText
            style={{
              fontFamily: "MTNRegular",
              margin: 0,
              fontSize: 13,
              color: cardStatus === "Completed" ? "#0FAF4B" : "#EE2737",
            }}
          >
            {hideStatusText ? '' : status}
          </StyledText>
          {cardStatus === "Completed" ? (
            <CheckCircle
              style={{
                backgroundColor: "#0FAF4B",
                borderRadius: 100,
                padding: 5,
                marginLeft: 15,
              }}
            />
          ) : (
            <SmsRefresh
              style={{
                backgroundColor: "#EE2737",
                borderRadius: 100,
                padding: 5,
                marginLeft: 15,
              }}
            />
          )}
        </div>
      </div>
    </Box>
  );
};

export default ReferralStatusCard;
